import React from 'react';
import _ from 'lodash';


import component, {classnames} from './component';
import Link from './Link';
import {ArrowRight} from './icons';


export default component('SubNav', function({className, data, query, label, SearchBar, doNotHighlightParent, defaultQuery}) {
  return <div className={classnames(className, 'SubNav', {'SubNav--NoParentHighlight': doNotHighlightParent})}>
    {label &&
      <div className='SubNav-Label'>
        {label}
        <ArrowRight className='SubNav-LabelArrow' />
      </div>
    }
    {data.map((item, index) => {
      const queryStatic = item.get('query') && item.get('query').toJS();
      const q = _.cloneDeep(query) || {};
      _.merge(q, queryStatic);

      return <div className='SubNav-Item' key={index + q}>
        <Link name={item.get('name')} params={item.get('params') && item.get('params').toJS()}
              query={q} queryStatic={queryStatic} defaultSelected={defaultQuery && _.isEqual(queryStatic, defaultQuery)}>
          {item.get('title')}
        </Link>
      </div>
    })}
    {SearchBar &&
      <div className='SubNav-SearchBar'>
        {SearchBar}
      </div>
    }
  </div>;
});



// WEBPACK FOOTER //
// ./src/components/SubNav.js